import { Consolidated, EntityPicking } from '../../../../../core';
import { STATE_ORDER_DISPATCH } from '../../../../../picking/picking-shared/enum/state-order-dispatch.enum';
import { Constants } from '../../../../../core';
import { DataTableExternal } from '../../data-table-external.interface';
import { hasVisibleAssignment, hasVisiblePickingAssignment, iconsOfActionsList, TYPE_CONSOLIDATED } from './picking-consolidated.config';

export const consolidatedPickingExternal: DataTableExternal = {
  searchText: '',
  addText: '',
  checkbox: true,
  expandable: true,
  filter: false,
  filterDefault: '',
  disabled: false,
  partialField: '',
  showIcon: './assets/icon/ico_placeholder_documentos.svg',
  iconsOfActions: iconsOfActionsList.concat(
    {
       icon: 'block_user',
       tooltip: 'Desasignar pedidos',
       type: TYPE_CONSOLIDATED.CUSTOM_ACTION,
       hasVisibleCondition: (element: Consolidated[]) => {
         // El botón aparece solo cuando hay elementos seleccionados y todos están en estado CREATED
         return element && element.length > 0 && 
                element.every(x => x.state === STATE_ORDER_DISPATCH.CREATED);
       }
     },
  ),
  paginator: true,
  hasDisabledCheckBoxItem: (item: any) => {
    // if (VALIDATE_ROLES()) {
    //   return true;
    // }
    switch (item.state) {
      case STATE_ORDER_DISPATCH.TO_LOCATE:
      case STATE_ORDER_DISPATCH.IN_PICKING:
      case STATE_ORDER_DISPATCH.CONSOLIDATED:
      case STATE_ORDER_DISPATCH.PRE_DISPATCH:
      case STATE_ORDER_DISPATCH.INCOMPLETE_PICKING:
      case STATE_ORDER_DISPATCH.DISPATCHED:
        return false;
      case STATE_ORDER_DISPATCH.CREATED:
        const entities: EntityPicking[] = hasVisiblePickingAssignment();
        let enableAssignment = entities.find(e=>e.entityId ===item.entityCode) ? entities.find(e=>e.entityId ===item.entityCode).enableAssignment : false
        return hasVisibleAssignment() || enableAssignment ? false : true;
      default:
        return true;
    }
  },
  columns: [
    {
      title: 'N° de despacho',
      name: 'serialNumber',
      type: 'string',
      class: 'number-order-consolidated',
      sortServer: true,
      value: (element: Consolidated) =>
        element.serialNumber ? element.serialNumber : ''
    },
    {
      title: 'Cliente',
      name: 'customer.fullName',
      type: 'string',
      sortServer: true,
      value: (element: Consolidated) => element.customer.fullName
    },
    {
      title: 'Receptor',
      name: 'authorizedReceiver',
      type: 'string',
      sortServer: true,
      value: (element: Consolidated) => element.receiver
    },
    {
      title: 'Estado',
      name: 'stateOrderDispatch.name',
      type: 'string',
      class: 'center',
      sortServer: true,
      value: (element: Consolidated) => element.state
    },
    {
      title: 'Fill Rate',
      name: 'fillRate',
      type: 'string',
      class: 'center',
      sortServer: true,
      value: (element: Consolidated) => element.fillRate
    },
    {
      title: 'Fecha de despacho',
      name: 'dateDispatch',
      type: 'string',
      class: 'center',
      sortServer: true,
      value: (element: Consolidated) => element.retirementDate
    },
    {
      title: 'Fecha de creación de despacho',
      name: 'dateCreated',
      type: 'string',
      class: 'center',
      sortServer: true,
      value: (element: Consolidated) => element.dateCreated
    },
    {
      title: 'Fecha y hora de fin de trabajo en picking',
      name: 'consolidatedDate',
      type: 'string',
      class: 'center',
      sortServer: true,
      value: (element: Consolidated) => element.consolidatedDate
    },
    {
      title: 'Inicio ventana horaria',
      name: 'startDateDeliveryWindow',
      type: 'string',
      class: 'center',
      sortServer: true,
      value: (element: Consolidated) => element.startDateDeliveryWindow
    },
    {
      title: 'Fin ventana horaria',
      name: 'endDateDeliveryWindow',
      type: 'string',
      class: 'center',
      sortServer: true,
      value: (element: Consolidated) => element.endDateDeliveryWindow
    },
    {
      title: 'Tipo de despacho',
      name: 'dispatchTypeCode',
      type: 'string',
      class: 'center',
      editable: false,
      checkAll: false,
      sortServer: true,
      value: (element: Consolidated) => element.dispatchTypeCode
    },
    {
      title: 'Modalidad de Despacho',
      name: 'methodDeliveryName',
      type: 'string',
      class: 'center',
      editable: false,
      checkAll: false,
      sortServer: false,
      value: (element: Consolidated) => element.methodDeliveryName
    },
    {
      title: 'Medio de pago',
      name: 'paymentMethodName',
      type: 'string',
      class: 'center',
      sortServer: true,
      value: (element: Consolidated) => element.paymentMethodName ==='null'? '' : element.paymentMethodName
    },
    {
      title: 'Canal de venta',
      name: 'saleChannel',
      type: 'string',
      class: 'center',
      sortServer: true,
      value: (element: Consolidated) => element.saleChannel ? element.saleChannel: ""
    },
    {
      title: 'Tiempo transcurrido (horas)',
      name: 'timeElapsed',
      type: 'string',
      class: 'center',
      sortServer: false,
      value: (element: Consolidated) => element.timeElapsed ? element.timeElapsed : ""
    },
    {
      title: 'N° de Skus',
      name: 'numberOfSkus',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: Consolidated) => element.numberOfSkus
    },
    {
      title: 'Estado de pago',
      name: 'paymentStatus',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: Consolidated) => element.paymentStatus
    },
    {
      title: 'Monto original',
      name: 'totalAmount',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: Consolidated) => element.totalAmount
    },
    {
      title: 'Monto actual',
      name: 'totalAmountUpdated',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: Consolidated) =>
        element.saleChannel === 'Agora Shop'
          ? element.totalAmountUpdated
          : element.totalAmountUpdatedNotAgora
    },
    {
      title: 'Motivo de cancelación',
      name: 'cancellationReason',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: Consolidated) => element.cancellationReason
    },
    {
      title: 'Entidad de origen',
      name: 'originEntity',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: Consolidated) => element.route ? element.route.split('-')[0].trim() : ''
    },
    {
      title: 'Imagen',
      type: 'button',
      name: 'image',
      editable: false,
      checkAll: false,
      class: 'center',
      value: () => {
        return {
          icon: 'photo',
          svg: true,
          tooltip: 'Ver detalles del producto',
          class: 'recordColumn icon-table'
        };
      }
    },
    {
      title: '',
      type: 'button',
      name: 'map',
      editable: false,
      checkAll: false,
      class: 'center',
      value: () => {
        return {
          icon: 'forum',
          tooltip: 'Ver chat',
          class: 'recordColumn icon-table'
        };
      }
    }
  ]
};
